import { render, staticRenderFns } from "./ExamTypesList.vue?vue&type=template&id=0fd6347b&scoped=true"
import script from "./ExamTypesList.vue?vue&type=script&lang=js"
export * from "./ExamTypesList.vue?vue&type=script&lang=js"
import style0 from "./ExamTypesList.vue?vue&type=style&index=0&id=0fd6347b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6347b",
  null
  
)

export default component.exports